// SPDX-License-Identifier: MIT
// Pure per-project sync status, derived client-side (no DB field). Web: every
// project is inherently in the cloud. Desktop: "synced" iff the project's local id
// is a key in the syncmap (localId→cloudId), else "untied" (local-only, not yet
// pushed/pulled). "syncing" is a valid badge state reserved for a future in-progress
// indicator — this pure derivation never returns it (no caller sets it yet); it is
// part of the union so renderSyncBadge can paint it when a caller eventually does.
export type SyncStatus = 'cloud' | 'synced' | 'syncing' | 'untied';

export function syncStatusFor(
  row: { id: string },
  platform: 'web' | 'desktop',
  syncMap: Record<string, string>,
): SyncStatus {
  if (platform === 'web') return 'cloud';
  return Object.prototype.hasOwnProperty.call(syncMap, row.id) ? 'synced' : 'untied';
}
